export const CONTACT_FORM_MESSAGES = {
    nameRequired: 'Введите имя',
    emailRequired: 'Введите email',
    emailInvalid: 'Некорректный email',
    phoneRequired: 'Введите телефон',
    phoneInvalid: 'Номер должен содержать 11 цифр',
    contactRequired: 'Укажите контакт',
    questionRequired: 'Опишите вопрос',
    agreementRequired: 'Необходимо согласие с политикой конфиденциальности',
} as const;

export const trimRequired =
    (message: string) =>
    (value: unknown): true | string =>
        String(value ?? '').trim().length > 0 || message;

export const LARAVEL_REQUIRED_BY_FIELD: Record<string, string> = {
    name: CONTACT_FORM_MESSAGES.nameRequired,
    company: 'Введите название компании',
    email: CONTACT_FORM_MESSAGES.emailRequired,
    phone: CONTACT_FORM_MESSAGES.phoneRequired,
    city: 'Введите город',
    contact: CONTACT_FORM_MESSAGES.contactRequired,
};
